interface TierBadgeProps {
  tier: 'STANDARD' | 'SILVER' | 'GOLD';
}

export function TierBadge({ tier }: TierBadgeProps) {
  const colors = {
    STANDARD: 'bg-gray-100 text-gray-700 border-gray-300',
    SILVER: 'bg-blue-50 text-blue-700 border-blue-300',
    GOLD: 'bg-amber-50 text-amber-700 border-amber-300',
  };

  const labels = {
    STANDARD: 'Standard',
    SILVER: 'Silver',
    GOLD: 'Gold',
  };

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${colors[tier]}`}>
      {labels[tier]}
    </span>
  );
}
